import { gql } from '@apollo/client';

export default gql`
  {
    getAcquirers {
      id
      name
    }
  }
`;
